module.exports = " <div id=app> <div class=card> <h1 class=\"header header--strong\"> Welcome to ndchristie.com </h1> <p class=paragraph>This domain has mutliple subdomains for different projects. This site serves primarily as the portal for those projects.</p> </div> <div class=card> <redirect-timer url=http://portfolio.ndchristie.com> </redirect-timer></div> <div class=card> <social-list v-bind:item-list=socialItemList></social-list> </div> <footer class=\"card card--well\"> <p class=\"paragraph paragraph--fineprint\">&copy; 2016 N.D.Christie</p> </footer> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 11
 ** module chunks = 1
 **/